/* Gift upsell: gift box + greeting card editors and cart housekeeping.
   Adapted to Impulse 7.1 (Spiritly): the drawer is re-rendered from /cart?view=drawer
   and cart changes are announced with the document event "cart:updated". */
(() => {
  const ov = document.getElementById('sg-overlay');
  if (!ov) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CFG = {
    card: +ov.dataset.cardVariant, box: +ov.dataset.boxVariant,
    cardPrice: +ov.dataset.cardPrice, boxPrice: +ov.dataset.boxPrice,
    cardPrefix: ov.dataset.cardPrefix, boxHandle: ov.dataset.boxHandle
  };
  const CARDS = JSON.parse(document.getElementById('sg-cards').textContent);
  const PH = { l1: 'Dear Sam,', mm: 'Happy Birthday', l2: 'Cheers, Andrew' };
  const CHIPS = ['Happy Birthday', 'Congratulations', 'Cheers!', 'With love'];
  const mobile = matchMedia('(max-width: 767px)');
  const $ = (s, r = ov) => r.querySelector(s);
  const $$ = (s, r = ov) => [...r.querySelectorAll(s)];
  const money = c => {
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) {}
    return '£' + (c / 100).toFixed(2);
  };
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const S = { sel: 0, cart: null, counts: {}, which: null, opener: null, busy: false };
  // Hooks filled in by the mobile step-by-step card editor (bottom of this file)
  const ST = { open: null, enter: null, err: null, input: null, design: null };

  const api = (path, body) => fetch(root + path, body ? {
    method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
  } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(r => {
    // The cookie-banner script can hold cart updates back and return a bare { ok: false } stand-in.
    if (typeof r.json !== 'function') throw { description: 'Please respond to the cookie banner first, then try again.' };
    return r.json().then(d => { if (!r.ok) throw d; return d; });
  });
  // Greeting cards are the PRGRCARD products, one per design: spiritly-greeting-card-<design>
  const isCard = i => !!i.handle && i.handle.indexOf(CFG.cardPrefix) === 0;
  const isBoxAny = i => i.handle === CFG.boxHandle;
  // Only boxes added through this editor carry _for. Boxes bought from the product page are left alone.
  const isBox = i => isBoxAny(i) && i.properties && i.properties._for;
  const isBottle = i => !isCard(i) && !isBoxAny(i) && !i.gift_card && i.product_type !== 'Spiritly Gifting';
  const bottlesOf = cart => {
    const m = new Map();
    cart.items.filter(isBottle).forEach(i => {
      const id = String(i.variant_id), b = m.get(id);
      b ? (b.qty += i.quantity) : m.set(id, { id, qty: i.quantity, title: i.product_title, image: i.image });
    });
    return [...m.values()];
  };
  // The cart note becomes the order note, and Acumatica prints the order note in the GIFT MESSAGE box on the
  // docket that goes in the parcel. So the note holds only what the recipient should read:
  // - Greeting cards off: the customer's free-text gift message exactly as typed (snippets/gift-upsell-row.liquid;
  //   also kept as the cart attribute "Gift message").
  // - Greeting card in the basket: the card's lines.
  // Gift boxes are not written to the note: the box is its own product line on the docket, and which bottle it is
  // for stays on the box's order line ("For").
  const MSG_KEY = 'Gift message';
  let msgEl = null; // the message box the customer last typed in (the drawer and /cart page can both have one)
  const machineNote = n => /GIFT BOX x|GREETING CARD - /.test(n || '');
  const msgOf = cart => {
    const el = (msgEl && document.contains(msgEl)) ? msgEl : document.querySelector('[data-sg-msg]');
    if (el) return el.value.trim();
    const a = cart.attributes && cart.attributes[MSG_KEY];
    if (a != null) return String(a).trim();
    return cart.note && !machineNote(cart.note) ? cart.note.trim() : ''; // a note written before this change
  };
  const noteFor = (cart, msg = msgOf(cart)) => {
    const out = [], card = cart.items.find(isCard);
    if (card) {
      const p = card.properties || {};
      out.push(`GREETING CARD - ${card.product_title.replace(/^Spiritly Greeting Card\s*-\s*/i, '')} (${card.sku})`);
      ['Opening line', 'Message', 'Closing line'].forEach(k => { if (p[k]) out.push(p[k]); });
    }
    if (msg) { if (!out.length) return msg; out.push(msg); }
    return out.join('\n');
  };
  let lastCart = null;
  const setNoteFields = n => document.querySelectorAll('[data-sg-note]').forEach(i => (i.value = n));
  const syncNote = cart => {
    lastCart = cart;
    const msg = msgOf(cart), n = noteFor(cart, msg), body = {};
    setNoteFields(n);
    if (n !== (cart.note || '')) body.note = n;
    if (document.querySelector('[data-sg-msg]') && msg !== String((cart.attributes || {})[MSG_KEY] || '').trim()) body.attributes = { [MSG_KEY]: msg };
    return Object.keys(body).length ? api('cart/update.js', body).then(c => (lastCart = c)) : Promise.resolve(cart);
  };
  // Typing a gift message: keep every copy of the box and the hidden note field current at once (so going
  // straight to checkout sends the right note), and save it to the cart shortly after typing stops.
  let msgT;
  document.addEventListener('input', e => {
    const el = e.target && e.target.closest && e.target.closest('[data-sg-msg]');
    if (!el) return;
    msgEl = el;
    document.querySelectorAll('[data-sg-msg]').forEach(x => { if (x !== el) x.value = el.value; });
    if (lastCart) setNoteFields(noteFor(lastCart, el.value.trim()));
    clearTimeout(msgT); msgT = setTimeout(() => api('cart.js').then(syncNote).catch(() => {}), 400);
  });
  // Used by gift-box-addon.js right before it sends the customer to checkout.
  window.sgNote = () => api('cart.js').then(syncNote);
  const clearLines = lines => lines.length
    ? api('cart/update.js', { updates: Object.fromEntries(lines.map(l => [l.key, 0])) })
    : Promise.resolve();

  // ---- Re-render the drawer the way this theme does (Impulse + Spiritly custom drawer).
  // The full /cart page has no drawer to swap, so it simply reloads.
  const onCartPage = /\/cart\/?$/.test(location.pathname);
  function refreshCart() {
    if (onCartPage) { location.reload(); return new Promise(() => {}); }
    const recs = document.getElementById('cart-recommendations');
    const recHTML = recs ? recs.innerHTML : '';
    return fetch(root + 'cart?view=drawer&t=' + Date.now(), { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const cur = document.getElementById('CartDrawer'), nxt = doc.getElementById('CartDrawer');
        if (cur && nxt) {
          cur.innerHTML = nxt.innerHTML;
          const r = document.getElementById('cart-recommendations');
          if (r && recHTML) r.innerHTML = recHTML;
        }
        return api('cart.js');
      })
      .then(cart => {
        const cur = document.getElementById('CartDrawer');
        if (cur) cur.classList.toggle('is-empty', !cart.item_count);
        document.querySelectorAll('.cart-link__bubble').forEach(b => b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sg: true } }));
        return cart;
      });
  }

  // ---- Build designs, dots, chips
  const form = $('[data-sg-form]'), dWrap = $('[data-sg-designs]'), dots = $('[data-sg-dots]'), cardPanel = $('[data-sg-panel="card"]');
  CARDS.forEach((c, i) => {
    dWrap.insertAdjacentHTML('beforeend', `<button type="button" class="sg-design" data-i="${i}" aria-label="${esc(c.name)}" aria-pressed="false"><img src="${esc(c.thumb)}" alt="" loading="lazy"></button>`);
    dots.appendChild(document.createElement('span'));
  });
  CHIPS.forEach(t => $('[data-sg-chips]').insertAdjacentHTML('beforeend', `<button type="button" class="sg-pill" aria-pressed="false">${esc(t)}</button>`));

  function pick(i, scroll) {
    S.sel = i; const c = CARDS[i];
    const front = $('[data-sg-front]'); front.src = c.thumb; front.alt = `${c.name} card front`;
    $$('[data-sg-name]').forEach(n => (n.textContent = c.name));
    $$('.sg-design').forEach((b, j) => b.setAttribute('aria-pressed', j === i));
    [...dots.children].forEach((d, j) => d.classList.toggle('is-on', j === i));
    if (ST.design) ST.design(); // the mobile stepper shows the same design (e.g. one picked on the product page)
    if (scroll && mobile.matches) {
      const b = dWrap.children[i];
      dWrap.scrollTo({ left: b.offsetLeft - (dWrap.clientWidth - b.clientWidth) / 2, behavior: 'smooth' });
    }
  }
  dWrap.addEventListener('click', e => { const b = e.target.closest('.sg-design'); if (b) pick(+b.dataset.i, true); });
  let scrollT;
  dWrap.addEventListener('scroll', () => {
    if (!mobile.matches) return;
    clearTimeout(scrollT);
    scrollT = setTimeout(() => {
      const mid = dWrap.scrollLeft + dWrap.clientWidth / 2;
      let best = 0, bd = Infinity;
      [...dWrap.children].forEach((b, j) => { const d = Math.abs(b.offsetLeft + b.clientWidth / 2 - mid); if (d < bd) { bd = d; best = j; } });
      if (best !== S.sel) pick(best, false);
    }, 80);
  });

  // ---- Preview
  const setOpen = o => {
    cardPanel.classList.toggle('is-open', o);
    $$('[data-sg-fliplabel]').forEach(b => (b.textContent = o ? 'Close the card' : 'Open the card'));
  };
  function paint() {
    ['l1', 'mm', 'l2'].forEach(k => {
      const v = form.elements[k].value.trim(), o = $(`[data-sg-out="${k}"]`);
      o.textContent = v || PH[k]; o.classList.toggle('is-ph', !v);
    });
    $$('.sg-pill').forEach(p => p.setAttribute('aria-pressed', p.textContent === form.elements.mm.value));
  }
  // Emoji and pictographs can't be printed, so flag them as the customer types.
  const EMOJI = /[\p{Extended_Pictographic}\u{1F1E6}-\u{1F1FF}\u{FE0F}\u{200D}]/u;
  const hasEmoji = t => EMOJI.test(t.replace(/[©®™]/g, ''));
  form.addEventListener('input', () => {
    paint(); setOpen(true);
    const all = ['l1', 'mm', 'l2'].map(k => form.elements[k].value).join('');
    err('card', hasEmoji(all) ? 'Emoji can’t be printed on the card. Please remove them.' : '');
  });
  $('[data-sg-chips]').addEventListener('click', e => {
    const p = e.target.closest('.sg-pill'); if (!p) return;
    form.elements.mm.value = p.textContent; paint(); setOpen(true); err('card', '');
  });
  $$('[data-sg-flip]').forEach(el => el.addEventListener('click', e => { e.stopPropagation(); setOpen(!cardPanel.classList.contains('is-open')); }));
  form.addEventListener('focusin', e => { if (mobile.matches && e.target.matches('input')) { cardPanel.classList.add('is-typing'); setOpen(true); } });
  $('[data-sg-change]').addEventListener('click', () => {
    cardPanel.classList.remove('is-typing'); document.activeElement && document.activeElement.blur();
    requestAnimationFrame(() => pick(S.sel, true));
  });

  // ---- Open / close
  function err(which, msg) {
    const el = $(`[data-sg-panel="${which}"] [data-sg-error]`); el.textContent = msg; el.hidden = !msg;
    if (which === 'card' && ST.err) ST.err(msg);
  }
  function openPanel(which, opener) {
    if (S.which) return Promise.resolve();
    S.opener = opener; S.which = which;
    return api('cart.js').then(cart => {
      S.cart = cart;
      $$('[data-sg-panel]').forEach(p => (p.hidden = p.dataset.sgPanel !== which));
      which === 'card' ? fillCard(cart) : fillBox(cart);
      err(which, '');
      ov.hidden = false; document.documentElement.classList.add('sg-lock');
      requestAnimationFrame(() => requestAnimationFrame(() => ov.classList.add('is-shown')));
      setTimeout(() => { const x = $$(`[data-sg-panel="${which}"] .sg-x`).find(b => b.offsetParent); if (x) x.focus({ preventScroll: true }); }, 60);
      if (which === 'card') requestAnimationFrame(() => pick(S.sel, true));
    }).catch(() => { S.which = null; });
  }
  function close() {
    if (!S.which) return;
    S.which = null;
    if (ST.input) ST.input.blur(); // closes the mobile keyboard
    ov.classList.remove('is-shown'); document.documentElement.classList.remove('sg-lock');
    setTimeout(() => { if (S.which) return; ov.hidden = true; cardPanel.classList.remove('is-typing'); $$('.sg-panel').forEach(p => (p.style.transform = '')); }, 320);
    // The opener may have been replaced by a drawer refresh; fall back to the same control in the new drawer.
    let o = S.opener;
    if (!o || !document.contains(o)) o = document.querySelector(`#CartDrawer [data-sg-open="${o && o.dataset.sgOpen}"]`);
    if (o) o.focus({ preventScroll: true });
  }
  // Openers live in the drawer, so listen on the document.
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-sg-open]');
    if (t && !ov.contains(t)) { e.preventDefault(); openPanel(t.dataset.sgOpen, t); }
  });
  // Keep events inside the overlay so the theme's drawer doesn't react (outside-click close, Esc close, focus trap).
  ov.addEventListener('click', e => {
    if (e.target.closest('[data-sg-close]')) close();
    e.stopPropagation();
  });
  // The theme's drawer listens for Esc and focus in the capture phase, so intercept at the window first while an editor is open.
  ov.addEventListener('focusin', e => e.stopPropagation());
  // Esc closes on keydown; the theme closes the drawer on keyup, so swallow that keyup too.
  let swallowEsc = false;
  window.addEventListener('keyup', e => {
    if (S.which || (swallowEsc && e.key === 'Escape')) e.stopImmediatePropagation();
    if (e.key === 'Escape') swallowEsc = false;
  }, true);
  window.addEventListener('keydown', e => {
    if (!S.which) return;
    e.stopImmediatePropagation();
    if (e.key === 'Escape') { e.preventDefault(); swallowEsc = true; return close(); }
    // Return in the mobile card field does the same as NEXT on the opening line (on the long lines it starts a new line)
    if (e.key === 'Enter' && !e.isComposing && ST.enter && e.target === ST.input && ST.enter()) { e.preventDefault(); return; }
    if (e.key !== 'Tab') return;
    const p = $$('[data-sg-panel]').find(x => !x.hidden);
    const f = $$('button:not([disabled]),input:not([disabled])', p).filter(x => x.offsetParent);
    const a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    else if (!p.contains(document.activeElement)) { e.preventDefault(); a.focus(); }
  }, true);

  // Swipe down to close (mobile): the sheet header, and the step row of the card editor
  $$('.sg-head, .sg-stps__top').forEach(h => {
    let y0 = null, dy = 0; const panel = h.closest('.sg-panel');
    h.addEventListener('touchstart', e => { y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; }, { passive: true });
    h.addEventListener('touchmove', e => { if (y0 == null) return; dy = Math.max(0, e.touches[0].clientY - y0); panel.style.transform = `translateY(${dy}px)`; }, { passive: true });
    h.addEventListener('touchend', () => { panel.style.transition = ''; panel.style.transform = ''; if (dy > 80) close(); y0 = null; });
  });

  // Keep sheet + button above the iOS/Android keyboard. --sg-kb is the keyboard height when the page
  // doesn't resize for it (older iOS); --sg-vh is the visible height. .has-kb (keyboard measured, or the
  // mobile card field focused, since newer iOS resizes the whole page and the keyboard measures 0)
  // makes the card editor fill the visible area in its compact layout.
  let kbH = 0;
  const kbClass = () => ov.classList.toggle('has-kb', kbH > 80 || (mobile.matches && !!ST.input && document.activeElement === ST.input));
  if (window.visualViewport) {
    const vv = visualViewport;
    const kb = () => {
      kbH = Math.max(0, innerHeight - vv.height - vv.offsetTop);
      ov.style.setProperty('--sg-kb', kbH + 'px');
      ov.style.setProperty('--sg-vh', vv.height + 'px');
      kbClass();
    };
    vv.addEventListener('resize', kb); vv.addEventListener('scroll', kb); kb();
  }

  // ---- Greeting card
  function fillCard(cart) {
    const line = cart.items.find(isCard), p = (line && line.properties) || {};
    form.elements.l1.value = p['Opening line'] || '';
    form.elements.mm.value = p['Message'] || '';
    form.elements.l2.value = p['Closing line'] || '';
    S.sel = Math.max(0, CARDS.findIndex(c => c.id === p._design));
    cardPanel.classList.remove('is-typing'); setOpen(false); paint(); pick(S.sel, false);
    $('[data-sg-save-card]').textContent = line ? 'SAVE CARD' : `ADD CARD · ${money(CFG.cardPrice)}`;
    // Mobile stepper: a new card starts at step 1, a card already in the cart opens on the review step
    if (ST.open) ST.open(!!line);
  }
  $('[data-sg-save-card]').addEventListener('click', e => {
    const btn = e.currentTarget, v = k => form.elements[k].value.trim();
    if (btn.disabled) return;
    if (!v('l1') && !v('mm') && !v('l2')) return err('card', 'Write a message for inside the card.');
    if (hasEmoji(v('l1') + v('mm') + v('l2'))) return err('card', 'Emoji can’t be printed on the card. Please remove them.');
    // Each design is its own product (PRGRCARD01-10), so the order maps to the right item in Acumatica.
    const c = CARDS[S.sel], props = {};
    if (v('l1')) props['Opening line'] = v('l1');
    if (v('mm')) props['Message'] = v('mm');
    if (v('l2')) props['Closing line'] = v('l2');
    props._design = c.id; props._image = c.img;
    const old = S.cart.items.filter(isCard);
    btn.disabled = true; btn.classList.add('is-busy'); S.busy = true;
    clearLines(old)
      .then(() => api('cart/add.js', { items: [{ id: c.variant || CFG.card, quantity: 1, properties: props }] }))
      .then(() => done('card', old.length ? 'Greeting card updated' : `Greeting card added · ${money(CFG.cardPrice)}`))
      .catch(x => { S.busy = false; err('card', (x && x.description) || 'Sorry, something went wrong. Please try again.'); })
      .finally(() => { btn.disabled = false; btn.classList.remove('is-busy'); });
  });

  // ---- Mobile step-by-step card editor (under 768px; desktop keeps the modal above)
  // One input serves the three writing steps: its value/placeholder/maxlength change in place, so it
  // never leaves the page and iOS keeps the keyboard open between steps. BACK, NEXT and the chips
  // don't take focus (pointerdown/mousedown preventDefault). The stepper writes into the form above
  // and presses the existing save button, so saving, replacing a card, toast and refresh are unchanged.
  const st = $('[data-sg-steps]');
  if (st) {
    const STEPS = [
      { pane: 'design', t: 'Choose a design' },
      // Print: opening line 16pt (top), main message and closing line 12pt
      { pane: 'write', k: 'l1', t: 'Opening line', sub: 'Optional · printed larger, at the top', ph: 'Dear Sam,', max: 80, opt: true },
      { pane: 'write', k: 'mm', t: 'Main message', sub: 'Your message, in the middle', ph: 'Happy Birthday', max: 255, long: true },
      { pane: 'write', k: 'l2', t: 'Closing line', sub: 'Optional · who is it from?', ph: 'Cheers, Andrew', max: 255, opt: true, long: true },
      { pane: 'review', t: 'Check your card' }
    ];
    const EMPTY_MSG = 'Add at least one line before adding the card.';
    const q = s => st.querySelector(s), qa = s => [...st.querySelectorAll(s)];
    const input = q('[data-st-input]'), nextBtn = q('[data-st-next]'), backBtn = q('[data-st-back]');
    const chips = q('[data-st-chips]'), stErr = q('[data-st-error]'), chars = q('[data-st-chars]');
    const saveBtn = $('[data-sg-save-card]');
    const warn = q('[data-st-warn]');
    const val = k => form.elements[k].value;
    let step = 0;
    ST.input = input;
    input.addEventListener('focus', kbClass);
    input.addEventListener('blur', () => setTimeout(kbClass, 0));

    q('[data-st-grid]').innerHTML = CARDS.map((c, i) =>
      `<button type="button" data-i="${i}" aria-label="${esc(c.name)}" aria-pressed="false"><img src="${esc(c.thumb)}" alt="" loading="lazy"></button>`).join('');
    chips.innerHTML = CHIPS.map(t => `<button type="button" class="sg-pill" aria-pressed="false">${esc(t)}</button>`).join('');

    // Keep focus (and the keyboard) on the field when these are tapped
    [nextBtn, backBtn, chips].forEach(el => ['pointerdown', 'mousedown'].forEach(ev => el.addEventListener(ev, e => {
      if (document.activeElement === input) e.preventDefault();
    })));

    function paintDesign() {
      const c = CARDS[S.sel];
      qa('[data-st-front]').forEach(img => { img.src = c.thumb; img.alt = `${c.name} card front`; });
      qa('[data-st-name]').forEach(n => (n.textContent = c.name));
      qa('[data-st-grid] button').forEach((b, j) => b.setAttribute('aria-pressed', j === S.sel));
    }
    function paintMini() {
      const s = STEPS[step];
      ['l1', 'mm', 'l2'].forEach(k => {
        const v = val(k).trim(), p = q(`[data-st-p="${k}"]`), r = q(`[data-st-r="${k}"]`);
        p.textContent = v || PH[k]; p.classList.toggle('is-ph', !v); p.classList.toggle('is-now', k === s.k);
        r.textContent = v || PH[k]; r.classList.toggle('is-ph', !v);
      });
      qa('[data-st-chips] .sg-pill').forEach(b => b.setAttribute('aria-pressed', b.textContent === val('mm')));
      if (s.k) {
        chars.textContent = `${val(s.k).length}/${s.max}`;
        warn.hidden = !hasEmoji(val(s.k));
        nextBtn.textContent = s.opt && !val(s.k).trim() ? 'SKIP' : 'NEXT';
      }
    }
    function paintRows() {
      q('[data-st-rows]').innerHTML = [['l1', 'Opening line', 1], ['mm', 'Main message', 2], ['l2', 'Closing line', 3]].map(([k, t, n]) =>
        `<div class="sg-stp__row"><div><small>${t}</small><span>${esc(val(k).trim() || '—')}</span></div><button type="button" data-st-edit="${n}" aria-label="Edit ${t.toLowerCase()}">Edit</button></div>`).join('');
    }

    function go(n) {
      step = Math.max(0, Math.min(4, n));
      const s = STEPS[step];
      q('[data-st-count]').textContent = `Step ${step + 1} of 5`;
      qa('.sg-stps__bar span').forEach((b, j) => b.classList.toggle('is-on', j <= step));
      q('[data-st-title]').textContent = s.t;
      const sub = q('[data-st-sub]'); sub.textContent = s.sub || ''; sub.hidden = !s.sub;
      qa('[data-st]').forEach(p => (p.hidden = p.dataset.st !== s.pane));
      backBtn.disabled = step === 0;
      stErr.hidden = true;
      nextBtn.disabled = false; nextBtn.classList.remove('is-busy');

      if (s.k) {
        // Same input for all three lines: change its settings, never re-create it
        input.value = val(s.k);
        input.placeholder = s.ph;
        input.maxLength = s.max;
        input.setAttribute('aria-label', s.t);
        // Return moves on from the opening line; on the long lines it starts a new line
        input.setAttribute('enterkeyhint', s.long ? 'enter' : 'next');
        input.classList.toggle('is-long', !!s.long);
        chips.hidden = s.k !== 'mm';
        if (document.activeElement !== input) input.focus({ preventScroll: true });
        try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
      } else {
        input.blur();
        nextBtn.textContent = step === 4 ? saveBtn.textContent : 'NEXT';
        if (step === 4) paintRows();
      }
      paintDesign(); paintMini();
      q('.sg-stps__body').scrollTop = 0;
    }

    input.addEventListener('input', () => {
      const k = STEPS[step].k; if (!k) return;
      form.elements[k].value = input.value;
      form.dispatchEvent(new Event('input', { bubbles: true })); // keeps the form, emoji check and desktop preview in step
      paintMini();
    });
    chips.addEventListener('click', e => {
      const b = e.target.closest('.sg-pill'); if (!b) return;
      input.value = b.textContent; input.dispatchEvent(new Event('input'));
      if (document.activeElement !== input) input.focus({ preventScroll: true });
    });
    q('[data-st-grid]').addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      pick(+b.dataset.i, false); paintDesign();
    });
    q('[data-st-rows]').addEventListener('click', e => {
      const b = e.target.closest('[data-st-edit]'); if (b) go(+b.dataset.stEdit);
    });
    backBtn.addEventListener('click', () => go(step - 1));
    const next = () => {
      if (step < 4) return go(step + 1);
      if (!['l1', 'mm', 'l2'].some(k => val(k).trim())) { stErr.textContent = EMPTY_MSG; stErr.hidden = false; return; }
      nextBtn.disabled = true; nextBtn.classList.add('is-busy');
      saveBtn.click(); // existing save: replaces any card in the cart, toast, drawer refresh
      if (!S.busy) { nextBtn.disabled = false; nextBtn.classList.remove('is-busy'); } // stopped by validation
    };
    nextBtn.addEventListener('click', next);

    // Return on the opening line = NEXT (routed from the window keydown handler above)
    ST.enter = () => { const s = STEPS[step]; if (!s.k || s.long) return false; next(); return true; };
    ST.design = () => paintDesign();
    // Save errors (emoji, network) show on the review step
    ST.err = msg => {
      if (step !== 4) return;
      nextBtn.disabled = false; nextBtn.classList.remove('is-busy');
      if (msg) { stErr.textContent = msg; stErr.hidden = false; } else stErr.hidden = true;
    };
    ST.open = editing => {
      stErr.textContent = EMPTY_MSG;
      if (!mobile.matches) return;
      go(editing ? 4 : 0);
    };
  }

  // ---- Gift box
  function fillBox(cart) {
    const list = $('[data-sg-bottles]'); S.counts = {};
    cart.items.filter(isBox).forEach(b => { const f = b.properties._for; S.counts[f] = (S.counts[f] || 0) + b.quantity; });
    list.innerHTML = bottlesOf(cart).map(b => {
      S.counts[b.id] = Math.min(S.counts[b.id] || 0, b.qty);
      const img = b.image ? `<img src="${esc(b.image)}${b.image.includes('?') ? '&' : '?'}width=120" alt="">` : '<span></span>';
      return b.qty === 1
        ? `<label class="sg-bottle" data-id="${b.id}"><input type="checkbox"${S.counts[b.id] ? ' checked' : ''}>${img}<span>${esc(b.title)}<small>${money(CFG.boxPrice)}</small></span></label>`
        : `<div class="sg-bottle sg-bottle--multi" data-id="${b.id}" data-max="${b.qty}">${img}<span>${esc(b.title)}<small>You have ${b.qty} · ${money(CFG.boxPrice)} each</small></span>
           <div class="sg-step"><button type="button" data-d="-1" aria-label="Fewer gift boxes for ${esc(b.title)}">−</button><span aria-live="polite">${S.counts[b.id]}</span><button type="button" data-d="1" aria-label="More gift boxes for ${esc(b.title)}">+</button></div></div>`;
    }).join('');
    paintBox();
  }
  function paintBox() {
    $$('.sg-bottle').forEach(r => {
      const n = S.counts[r.dataset.id] || 0; r.classList.toggle('is-on', n > 0);
      const s = r.querySelector('.sg-step span'); if (s) s.textContent = n;
      const [dn, up] = r.querySelectorAll('.sg-step button'); if (dn) { dn.disabled = !n; up.disabled = n >= +r.dataset.max; }
    });
    const n = bottlesOf(S.cart).reduce((a, b) => a + (S.counts[b.id] || 0), 0), had = S.cart.items.some(isBox), b = $('[data-sg-save-box]');
    b.disabled = !n && !had;
    b.textContent = n ? `ADD ${n} GIFT BOX${n > 1 ? 'ES' : ''} · ${money(n * CFG.boxPrice)}` : had ? 'REMOVE GIFT BOXES' : 'CHOOSE A BOTTLE';
  }
  $('[data-sg-bottles]').addEventListener('change', e => { const r = e.target.closest('.sg-bottle'); if (r) { S.counts[r.dataset.id] = e.target.checked ? 1 : 0; paintBox(); } });
  $('[data-sg-bottles]').addEventListener('click', e => {
    const btn = e.target.closest('[data-d]'); if (!btn) return;
    const r = btn.closest('.sg-bottle'), id = r.dataset.id;
    S.counts[id] = Math.max(0, Math.min(+r.dataset.max, (S.counts[id] || 0) + +btn.dataset.d)); paintBox();
  });
  $('[data-sg-save-box]').addEventListener('click', e => {
    const btn = e.currentTarget;
    if (btn.disabled) return;
    const items = bottlesOf(S.cart).filter(b => S.counts[b.id] > 0)
      .map(b => ({ id: CFG.box, quantity: S.counts[b.id], properties: { 'Gift box for': b.title, _for: b.id } }));
    const n = items.reduce((a, i) => a + i.quantity, 0);
    btn.disabled = true; btn.classList.add('is-busy'); S.busy = true;
    clearLines(S.cart.items.filter(isBox))
      .then(() => items.length ? api('cart/add.js', { items }) : null)
      .then(() => done('box', n ? `${n} gift box${n > 1 ? 'es' : ''} added · ${money(n * CFG.boxPrice)}` : 'Gift boxes removed'))
      .catch(x => { S.busy = false; err('box', (x && x.description) || 'Sorry, something went wrong. Please try again.'); })
      .finally(() => { btn.classList.remove('is-busy'); paintBox(); });
  });

  // ---- After saving
  const toastEl = document.getElementById('sg-toast'); let toastT;
  function done(kind, msg) {
    close();
    return api('cart.js').then(syncNote).catch(() => {}).then(refreshCart).then(() => {
      S.busy = false;
      toastEl.textContent = msg; toastEl.classList.add('is-shown');
      clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-shown'), 2400);
      document.querySelectorAll(`[data-sg-line="${kind}"]`).forEach(l => { l.classList.add('is-flash'); setTimeout(() => l.classList.remove('is-flash'), 1600); });
    }).catch(() => { S.busy = false; });
  }

  // ---- Housekeeping: orphaned boxes, 1 card max, no card without bottles
  let syncing = false;
  window.sgSync = () => {
    if (syncing || S.busy) return Promise.resolve();
    syncing = true;
    return api('cart.js').then(cart => {
      const upd = {}, left = {};
      bottlesOf(cart).forEach(b => (left[b.id] = b.qty));
      cart.items.filter(isBox).forEach(l => {
        const f = l.properties._for, m = left[f] || 0, q = Math.min(l.quantity, m);
        left[f] = m - q; if (q !== l.quantity) upd[l.key] = q;
      });
      const noBottles = !bottlesOf(cart).length;
      cart.items.filter(isCard).forEach((l, j) => { const q = noBottles || j > 0 ? 0 : 1; if (l.quantity !== q) upd[l.key] = q; });
      // Keep the order note in step with the card / boxes (e.g. after a line is removed).
      if (!Object.keys(upd).length) return syncNote(cart);
      return api('cart/update.js', { updates: upd }).then(syncNote).then(refreshCart);
    }).catch(() => {}).finally(() => { syncing = false; });
  };
  // The theme fires "cart:updated" after quantity changes, removals and adds. Our own refresh is flagged with detail.sg.
  let syncT;
  document.addEventListener('cart:updated', e => {
    if (e.detail && e.detail.sg) return;
    clearTimeout(syncT); syncT = setTimeout(window.sgSync, 250);
  });
  window.sgSync();
})();
